import React from 'react';
import { Button } from 'semantic-ui-react';

import { useAssistantContext } from './context';

import './assistant.scss';

// FIN-1314: the button that opens the assistant — in the header of every page, next to the
// person's name, for the people the assistant is switched on for (users.ai_assistant).
const AssistantLauncher = () => {
  const { enabled, open, setOpen } = useAssistantContext();
  if (!enabled) return null;

  return (
    <Button
      circular
      primary
      icon="magic"
      size="small"
      className="assistant-launcher"
      aria-label={open ? 'Close assistant' : 'Open assistant'}
      title="Assistant"
      active={open}
      onClick={() => setOpen(!open)}
    />
  );
};

export default AssistantLauncher;
